﻿
window.leadershipToggle = function () {

	// headings
	var headings = document.querySelectorAll('.pod--board__title');
	// toggle buttons
	var buttons = document.querySelectorAll('.pod--board__toggle');

	var cssClass = 'expanded';

	// add click events to toggle a css class on the parent pod..

	headings.forEach(function (el, i) {
		el.addEventListener('click', function () {
			if (el.parentNode.classList.contains(cssClass)) {
				el.parentNode.classList.remove(cssClass);
			} else {
				el.parentNode.classList.add(cssClass)
            }
        })
	})

	buttons.forEach(function (el, i) {
		el.addEventListener('click', function () {
			if (el.parentNode.classList.contains(cssClass)) {
				el.parentNode.classList.remove(cssClass);
			} else {
				el.parentNode.classList.add(cssClass)
			}
		})
	})

}

if (document.readyState !== 'loading') {
	window.leadershipToggle();
} else {
	document.addEventListener('DOMContentLoaded', function () {
		window.leadershipToggle();
	});
}